export const defaultTheme = {
  colors: {
    text: '#000000',
    background: '#FFFFFF',
    primary: '#2B3A5B',
    accent: '#FF6D34',
    border: '#D3D3D3',
  },
  typography: {
    fontBase: 'Avenir, system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
    fontDisplay: '"Cooper Black", Avenir, system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
  },
};

